const messages = {
  'menu.print': 'Print',
  'menu.freight': 'Freight',
  'menu.jdfreightbill': 'JD Freight Bill Management',
  'menu.sffreightbill': 'SF Freight Bill Management',
  'menu.dhlfreightbill': 'DHL Freight Bill Management',
  'menu.fedexfreightbill': 'FedEx Freight Bill Management',
  'menu.emsfreightbill': 'EMS Freight Bill Management',
  'menu.jdfreightbillreport': 'JD Freight Bill Report',
  'menu.sffreightbillreport': 'SF Freight Bill Report',
  'menu.dhlfreightbillreport': 'DHL Freight Bill Report',
  'menu.fedexfreightbillreport': 'FedEx Freight Bill Report',
  'menu.emsfreightbillreport': 'EMS Freight Bill Report',
  'menu.report': 'Reports',  
  'menu.settings':'Settings',
  'menu.systemmanagement': 'System Management',
  'menu.masterdata': 'Master Data Management', 
  'menu.emailtemplate': 'Email Template Management',
  'menu.carriers': 'Carriers Management',
  'menu.paymentaccount': 'Carrier Payment Account Management',
  'menu.carrieraccount':'Carrier Account Management',
  'menu.freightbillaccount':'Freight Bill Account Management',
  'menu.porequest':'PO Request',
  'menu.shipments':'Shipments',
  'menu.details':'Details',
  'menu.dninformation':'DN Information',
  'menu.exportdeclarationinformation':'Export Declaration Information',
  'menu.shipmentinformation':'Shipment Tracking Information',
  'menu.freightinformation':'Freight Information',
  'menu.company': 'Company Management',
  'menu.department': 'Department Management',
  'menu.country': 'Country/Region Management',
  'menu.state': 'State Management',
  'menu.hscode': 'HS Code Management',
  'menu.legalunit': 'Legal Unit Management',
  'menu.sparrowtemplate': 'Sparrow Template Management',
  'menu.addressbook': 'Address Book Management',
  'menu.expressservice': 'Create Shipment',
  'menu.createdomesticexpressorder': 'Domestic Express',
  'menu.updatedomesticexpressorder': 'Update Domestic Express',
  'menu.createinternationalexpressorder': "Export Express",
  'menu.updateinternationalexpressorder': "Update Export Express",
  'menu.expressorderdetail': 'Shipment Detail',
  'menu.expressorderprocess': 'Process Shipment',
  'menu.expressorderreport': 'Shipments',
  'menu.expressordertodolist': 'Pending Approval',
  'menu.dashboard': 'Dashboard',
  'menu.shipmentsreport': 'Shipments Report',
  'menu.purchaserequest': 'Purchase Request',
  'menu.purchaserequesttodo': 'Purchase Request ToDo List',
  'menu.purchaserequestreport': 'Purchase Request Report',
  'menu.purchaserequestdetail': 'Purchase Request',
  'menu.updatepurchaserequest': 'Update Purchase Request',
  'menu.copypurchaserequest': 'Copy Purchase Request',
  'menu.changepurchaserequest': 'Change Purchase Request',
  'menu.delegation': 'Delegation Management'
};
export default messages;
